import { render, staticRenderFns } from "./Subtitles.vue?vue&type=template&id=7b523248&"
import script from "./Subtitles.vue?vue&type=script&lang=js&"
export * from "./Subtitles.vue?vue&type=script&lang=js&"
import style0 from "./Subtitles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports